/**
 * DevExtreme (esm/__internal/grids/data_grid/m_core.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import modules from "../../grids/grid_core/m_modules";
import gridCoreUtils from "../../grids/grid_core/m_utils";
export default _extends({}, modules, gridCoreUtils, {
  modules: []
});